<template>
  <div id="coach_official_check_outer" v-if="coach != null">
    <div style="height: 200px;line-height: 200px;">{{notice}}</div>
    <div v-if="coach.status == 8" style="display: flex;flex-direction: column;flex-wrap: nowrap;align-items: center;">
      <el-button class="bottom-button next-button" @click="backToFirstStep" round>返回修改</el-button>
      <a href="javascript:void(0)" style="margin-top: 20px;color: #333;text-decoration: underline;" @click="cancelButtonClicked">取消申请</a>
    </div>
  </div>
</template>

<script>
  export default {
    name: "CoachOfficialCheckVue",
    props: {
      coachItem: {
        type: Object,
        default: null,
      }
    },
    data() {
      return {
        notice: '',
        descList: [
          '您的身份认证信息正在复核，预计5个工作日完成。',
          '请替换该句错误提示！'
        ],
        coach: null,
      }
    },
    computed: {
      user() {
        return this.$store.state.user;
      },
      httpManager() {
        return this.$store.state.http;
      },
    },
    watch: {
      coachItem: {
        handler(val, oldVal) {
          if (val == null) {
            return;
          }
          if (val.coach == null) {
            return;
          }
          if (oldVal == null || oldVal.coach == null) {
            this.upadteData();
          }

          if (val.coach.status != oldVal.coach.status) {
            this.upadteData();
          }
        },
        deep: true
      }
    },
    mounted() {
      this.upadteData();
    },
    methods: {
      upadteData() {
        let coachItem = this.coachItem;
        if (coachItem != null) {
          let coach = coachItem.coach;
          let status = coach.status;
          if (status == 6) {
            this.notice = this.descList[0];
          } else if (status == 8) {
            this.notice = coach.auditRemark;
          }
          this.coach = coach;
        }
      },

      backToFirstStep() {
        let auditRemark = this.coachItem.coach.auditRemark;
        if (auditRemark != null && auditRemark != '') {
          this.$store.commit('setIdErrorRemark', auditRemark);
        }
        this.$emit("baktoPreview");
      },
      cancelButtonClicked() {
        let _this = this;
        this.$confirm('取消后，您本次提交的材料将会清空，请确认是否需要取消本次认证？', '提示', {
          confirmButtonText: '是',
          cancelButtonText: '否',
          type: 'warning',
        }).then(() => {
          //...操作取消申请相关处理
          _this.$emit("delete");
        });
      }
    },
  }

</script>

<style scoped>
  @import url("../../../css/back-next-buttons.css");
  #coach_official_check_outer {
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/personal/coachApplications/CoachOfficialCheck.vue